import styled from "styled-components";

export const InnovatsiyaWrapper = styled.div``